import { useUserInfoQuery } from '../../__generated__/graphql';

export type ForcedPrivateCheerSettings = {
  forceBirthdayCheersPrivate: boolean;
  forceCongratsCheersPrivate: boolean;
};

// Cheers of the matching type are forced private (no public option) when set.
export const useForcedPrivateCheerSettings = (): ForcedPrivateCheerSettings => {
  const userInfo = useUserInfoQuery();
  const hubFeatures = userInfo.data?.employeeHubFeatures;

  return {
    forceBirthdayCheersPrivate:
      (hubFeatures as any)?.flair__Force_Birthday_Cheers_Private__c === true,
    forceCongratsCheersPrivate:
      (hubFeatures as any)?.flair__Force_Congrats_Cheers_Private__c === true,
  };
};
